import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SKIP_KEY = 'mt_rides_emergency_nudge_skip';
const DONE_KEY = 'mt_rides_emergency_nudge_done';
const SEEN_AT_KEY = 'mt_rides_emergency_nudge_seen_at';
const SNOOZE_MS = 10 * 24 * 60 * 60 * 1000; // 10 days

const shouldHideNudge = () => {
  try {
    if (localStorage.getItem(DONE_KEY) === '1') return true;
    if (localStorage.getItem(SKIP_KEY) === '1') return true;
    const seenAt = Number(localStorage.getItem(SEEN_AT_KEY) || 0);
    if (seenAt && Date.now() - seenAt < SNOOZE_MS) return true;
  } catch { /* */ }
  return false;
};

/** Soft nudge when SOS contacts are empty — auto-snoozes 10 days after first view. */
export default function EmergencyContactsPrompt({ uid, t, contacts, hidden: forceHidden = false }) {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(() => shouldHideNudge());

  const hasContacts = (contacts || []).some((c) => String(c?.phone || '').replace(/\D/g, '').length === 10);

  // Mark done when contacts exist (saved from Profile).
  useEffect(() => {
    if (!hasContacts) return;
    try {
      localStorage.setItem(DONE_KEY, '1');
      localStorage.removeItem(SKIP_KEY);
      localStorage.removeItem(SEEN_AT_KEY);
    } catch { /* */ }
    setHidden(true);
  }, [hasContacts]);

  // First paint → start 10-day snooze clock.
  useEffect(() => {
    if (!uid || hidden || hasContacts) return;
    try {
      if (!localStorage.getItem(SEEN_AT_KEY)) {
        localStorage.setItem(SEEN_AT_KEY, String(Date.now()));
      }
    } catch { /* */ }
  }, [uid, hidden, hasContacts]);

  if (!uid || hidden || forceHidden || hasContacts) return null;

  const skip = () => {
    try {
      localStorage.setItem(SKIP_KEY, '1');
      localStorage.setItem(SEEN_AT_KEY, String(Date.now()));
    } catch { /* */ }
    setHidden(true);
  };

  const go = () => {
    setHidden(true);
    navigate('/profile');
  };

  return (
    <div className="push-prompt emergency-nudge">
      <div>
        <strong>{t('safety.nudgeTitle')}</strong>
        <p>{t('safety.nudgeBody')}</p>
      </div>
      <div className="push-prompt-actions">
        <button type="button" className="btn btn-ghost" onClick={skip}>{t('push.later')}</button>
        <button type="button" className="btn btn-primary" onClick={go}>{t('safety.nudgeAdd')}</button>
      </div>
    </div>
  );
}
